import React from 'react';

import { Box, Card, CardBody, Text } from 'grommet';

import { Folder, Star, FormView, Code, Network } from 'grommet-icons';

const RepoDetails = ({
  name,
  description,
  language,
  stargazers,
  watchers,
  forks,
}: any) => (
  <>
    <Box gap="small" align="center" direction="row" pad="small">
      <Folder color="brand" size="large" />
      <Box>
        <Text size="xxlarge" weight="bold">
          {name}
        </Text>
        <Text size="small">{description}</Text>
      </Box>
    </Box>
    <Box gap="small" align="center" direction="row" pad="small">
      <b>Language</b>: {language ? language : 'N/A'}
      <Code size="medium" color="brand" />
    </Box>
    <Box gap="small" align="center" direction="row" pad="small">
      <b>Stargazers</b>: {stargazers}
      <Star size="medium" color="brand" />
    </Box>
    <Box gap="small" align="center" direction="row" pad="small">
      <b>Watchers</b>: {watchers}
      <FormView size="medium" color="brand" />
    </Box>
    <Box gap="small" align="center" direction="row" pad="small">
      <b>Forks</b>: {forks}
      <Network size="medium" color="brand" />
    </Box>
  </>
);

const InfoCard = (repo: any) => {
  const onClick = () => window.open(repo.url, '_blank');
  return (
    <Box pad="large" align="start">
      <Card elevation="large" width="500px" onClick={onClick}>
        <CardBody pad="small">
          <RepoDetails {...repo} />
        </CardBody>
      </Card>
    </Box>
  );
};

export { InfoCard };
